import React, { useState } from "react";
import { SearchGlobalContext } from "@/components/Modals/SearchGlobalModal/utils";
import throttle from "lodash/throttle";
import SearchListItem from "../../ListItem";
import ListEmptyPlaceholder from "@jd/focus-desktop-comps/lib/es/ListEmptyPlaceholder";
import { Spin } from "antd";
import GroupTitle from "@/components/Modals/SearchGlobalModal/GroupTitle";
import lodashTrim from "lodash/trim";
import { SearchGlobalParams, SearchType } from "@/services/SearchService";
import { ListItemData } from "@/components/ListItem";
import { getHighlightComp } from "@/utils/search";
import dayjs from "dayjs";
import styles from "./tabPaneSub.module.less";

export default function TabPaneTask() {
  const { onSearchGlobal, keyword, t, activeKey } = React.useContext(SearchGlobalContext);
  const [loading, setLoading] = React.useState(false);
  const [subs, setSubs] = useState<ListItemData[]>([]);
  const [pages, setPages] = useState<ListItemData[]>([]);
  const keywordRef = React.useRef<string>();
  keywordRef.current = keyword;
  const activeKeyRef = React.useRef<SearchType>();
  activeKeyRef.current = activeKey;

  const doSearch = async () => {
    if (activeKeyRef.current !== SearchType.Sub) {
      return;
    }
    if (!keywordRef.current) {
      return [];
    }
    try {
      setLoading(true);
      const params: SearchGlobalParams = {
        keyword: keywordRef.current,
        searchType: SearchType.Sub,
        pageNo: 1,
        pageSize: 20
      };

      const res = await onSearchGlobal(params);

      if (keywordRef.current) {
        setSubs(
          res.subs?.map((i) => ({
            id: i.subId as string,
            name: getHighlightComp(i.highlight, "subName", i.subName),
            avatar: i.avatar,
            desc: getHighlightComp(i.highlight, "brief", i.brief)
          })) || []
        );
        setPages(
          res.subPages?.map((i) => ({
            id: i.pageId as string,
            name: getHighlightComp(i.highlight, "title", i.title),
            avatar: i.headImg,
            desc: getHighlightComp(i.highlight, "summary", i.summary),
            ext: `${i.author} ${dayjs(i.createTime).format("YYYY-MM-DD")}`
          })) || []
        );
      }
      setLoading(false);
    } catch (e) {
      setSubs([]);
      setPages([]);
      setLoading(false);
    }
  };

  const doSearchThrottle = React.useRef(throttle(doSearch, 500)).current;

  React.useEffect(() => {
    if (!lodashTrim(keywordRef.current)) {
      setSubs([]);
      setPages([]);
      return;
    }
    doSearchThrottle();
  }, [keyword, doSearchThrottle, activeKey]);

  if (!subs.length && !pages.length) {
    return <ListEmptyPlaceholder placeholder={t("search.emptySub")} />;
  }

  return (
    <Spin spinning={loading} wrapperClassName={styles.wrap}>
      {subs.length ? <GroupTitle title="组织号" /> : null}
      {subs.map((item, index) => {
        return (
          <SearchListItem
            key={index}
            data={item}
            onClick={() => {
              console.info("item", item);
              // 跳转到组织号会话
            }}
            t={t}
          />
        );
      })}

      {pages.length ? <GroupTitle title="组织号内容" /> : null}
      {pages.map((item, index) => {
        return (
          <div key={index}>
            <SearchListItem
              data={item}
              onClick={() => {
                console.info("item", item);
                // 打开内容详情
              }}
              t={t}
            />
            <div
              style={{
                color: "#8E8E8E",
                paddingLeft: "78px",
                marginTop: -30,
                position: "relative",
                zIndex: 99
              }}
            >
              {item.ext}
            </div>
          </div>
        );
      })}
    </Spin>
  );
}
